export default "__VITE_ASSET__Cnq5FN3U__"